import {lazy} from '../lazy.js';
import {float, extract} from '../utils.js';
import {doc} from '../../docs.js';
import {extractCode} from '../extract.js';

doc(
    "gl.cx_div",
    {
        "a": "vec2",
        "b": "vec2",
    },
    "Complex division in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);
export const gl_cx_div = (object, _b) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a,b] = extractCode(_a,_b);
        a = '(' + float(a) + ')';
        b = '(' + float(b) + ')';
        return `cx_div(${a}, ${b})`;
    }, _b);
};

doc(
    "gl.cx_mul",
    {
        "a": "vec2",
        "b": "vec2",
    },
    "Complex division in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);
export const gl_cx_mul = (object, _b) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a,b] = extractCode(_a,_b);
        a= '(' + float(a) + ')';
        b= '(' + float(b) + ')';
        return `cx_mul(${a}, ${b})`
    }, _b);
};

doc(
    "gl.cx_sin",
    {
        "a": "vec2",
    },
    "Complex sin in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 1
    }
);
export const gl_cx_sin = (object) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a] = extractCode(_a);
        a= '(' + float(a) + ')';
        return `cx_sin(${a})`;
    });
};


doc(
    "gl.cx_cos",
    {
        "a": "vec2",
    },
    "Complex cos in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 1
    }
);
export const gl_cx_cos = (object) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a] = extractCode(_a);
        a= '(' + float(a) + ')';
        return `cx_cos(${a})`;
    });
};

doc(
    "gl.cx_tan",
    {
        "a": "vec2",
    },
    "Complex cos in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 1
    }
);
export const gl_cx_tan = (object) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a] = extractCode(_a);
        a= '(' + float(a) + ')';
        return `cx_div(cx_sin(${a}), cx_cos(${a}))`;
    });
};

const as_polar =  {
    args: {
        "z": "vec2",
    },
    returnType: "vec2",
    body: `
    return vec2(
    length(z),
    atan(z.y, z.x)
  );
`
};

doc(
    "gl.cx_log",
    {
        "a": "vec2",
    },
    "Complex tan in glsl",
);
export const gl_cx_log = (object) => {
    object.needsHotReload = true;
    return ([msg]) => {
        let {codes, uniforms, functions, variables} = extract(msg);
        variables = msg.variables;
        functions['as_polar'] = as_polar;

        functions['cx_log'] = {
            args: {
                'a': 'vec2',
            },
            returnType: 'vec2',
            body: `
    vec2 polar = as_polar(a);
    float rpart = polar.x;
    float ipart = polar.y;
    if (ipart > PI) ipart=ipart-(2.0*PI);
    return vec2(log(rpart),ipart);
`
        };

        return {
            code: `cx_log(${float(codes[0])})`,
            uniforms,
            functions,
            variables,
        };
    }
};

doc(
    "gl.cx_pow",
    {
        "a": "vec2",
        "b": "float",
    },
    "Complex power in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);
export const gl_cx_pow = (object, p) => {
    object.needsHotReload = true;
    return ([v]) => {
        let {codes, uniforms, functions, variables} = extract(v, p);
        functions['as_polar'] = as_polar;
        functions['cx_pow'] = {
            args: {
                'v': 'vec2',
                'p': 'float',
            },
            returnType: 'vec2',
            body: `
    vec2 z = as_polar(v);
    return pow(z.x, p) * vec2(cos(z.y * p), sin(z.y * p));
`
        };

        return {
            code: `cx_pow(${float(codes[0])}, ${float(codes[1])})`,
            uniforms,
            functions,
            variables,
        };
    };
};

doc(
    "gl.im",
    {
        "a": "vec2",
    },
    "Complex imaginary part in glsl",
    () => 1,
    {
        isHot: true,
        inlets: 1
    }
);
export const gl_im = (object, _b) => {
    object.needsHotReload = true;
    return lazy((_a) => {
        let [a] = extractCode(_a);
        a = '(' + float(a) + ')';
        return `(((atan(${a}.y, ${a}.x) / PI) + 1.0) * 0.5)`;
    });
};


export const complex = {
    'gl.cx_pow': gl_cx_pow,
    'gl.cx_div': gl_cx_div,
    'gl.cx_sin': gl_cx_sin,
    'gl.cx_cos': gl_cx_cos,
    'gl.cx_mul': gl_cx_mul,
    'gl.cx_log': gl_cx_log,
};

